import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PipesModule, Store } from "@vattenfall/core";
import { ErrorModule, LoadingModule, TruncateModule, TooltipModule } from "@vattenfall/ui";

import { CampaignProductCardFinlandElement } from "./campaign-product-card-finland.element";

@NgModule({
  declarations: [CampaignProductCardFinlandElement],
  imports: [CommonModule, PipesModule, ErrorModule, LoadingModule, TruncateModule, TooltipModule],
  exports: [CampaignProductCardFinlandElement],
  bootstrap: [CampaignProductCardFinlandElement],
  providers: [Store],
})
export class CampaignProductCardFinlandModule {}
